
<template>

  <div class="nextStepContainer">
  	<div v-on:click="goToNext" v-bind:class="{ nextStep: true, notActive: !nextStepActive }">
  		 <div v-html="nextStepText" class="button adapted black u-full-width">
  		 </div>
  	</div>

    <!-- Previous button -->
    <div v-if="currentPicker != 'backgrounds'" v-on:click="goToPrev" class="close button hide-for-mobile adapted">
      {{ $t('goBackToStep') }}
    </div>

    <div v-on:click="closePickers" class="closePickers button adapted show-for-mobile">
      <i class="icon-close"></i> {{ $t('close') }}
    </div>
  </div>
</template>

<script>

export default {
  data: function(){
    return{

    }
  },

  computed: {

    nextStepText(){

      if(this.currentPicker == 'frames'){
        return this.$t('done')
      }
      else if ($(window).width() <= 812) {
        return this.$t('moveOn')
      }
      else {
        return this.$t('saveAndMoveOn')
      }

    },

    nextStepActive(){

      var currentPicker = this.currentPicker;

      switch(currentPicker){

        case "backgrounds":
          return this.steps.background
        case "pictureWalls":
          return this.steps.pictureWall
        case "basket":
        case "articles":
          return true;
        case "frames":
          return true
        default: break;
      }

    },

    currentPickerNumber(){
      if(this.currentPicker){

        switch(this.currentPicker){

          case 'backgrounds': return 1;
          case 'pictureWalls': return 2;
          case 'basket': case 'articles': return 3;
          case 'frames': return 4;

        }

      }
    },

  },

  methods:{

  	/*------------------------------------------------------------------
      Go to next step
    ------------------------------------------------------------------*/

    goToNext(){

      var self = this;

      self.$store.commit('hideLeftMenu', true)

      // Go to next step depending on current picker
      var currentPicker = self.currentPicker;

      switch(currentPicker){

        case "backgrounds":
          self.openPicker('pictureWalls')
          break;
        case "pictureWalls":
          self.openBasket()
          break;
        case "basket":
        case "articles":

          // If we should move to frames
          if(self.steps.motifs){
            self.openFramePicker()
          }
          // If we should move to next article
          else{

            $.each(self.$store.state.chosenArticles, function(index, value){
              if(value == false){
                var position = parseInt(index) - 1;
                window.eventHub.$emit('clickPictureWallArticle', self.$store.state.pictureWall.articles[position]);
              }
            });

          }
          break;
        case "frames":
           window.eventHub.$emit('closePickers', 'picker');
          break;
        default:
            window.eventHub.$emit('closePickers', 'picker');
          break;

      }

      setTimeout(function(){
        self.$store.commit('hideLeftMenu', false)
      }, 300);

    },

    /*--------------------------------------------------
      Go to previous step
    --------------------------------------------------*/

    goToPrev(){

      var self = this;

      self.$store.commit('hideLeftMenu', true)

      switch(self.currentPicker){
          case 'pictureWalls':
            window.eventHub.$emit('openPicker', 'backgrounds');
            break;
          case 'basket':
          case 'articles':
            window.eventHub.$emit('openPicker', 'pictureWalls');
            break;
          case 'frames':
            window.eventHub.$emit('openBasket');
            break;
      }

      setTimeout(function(){
        self.$store.commit('hideLeftMenu', false)
      }, 300);

    },


    openPicker(type){

      // Open picker
      window.eventHub.$emit('openPicker', type);

    },

    openBasket(){
      window.eventHub.$emit('openBasket');
    },

    openFramePicker(){
      window.eventHub.$emit('openFramePicker');
    },

  },

}
</script>

<style>

.nextStepContainer{
  .closePickers{
      width: 100%;
    }

    .button{
      margin: 0;
      padding: 12px;
      font-size: 12px;
      float: left;
      width: 100%;

      /* Mobile */
      @media screen and (max-width: 812px) {
        padding: 9px;
        font-size: 10px;
        width: 100%;
      }
    }

    .closePickers{
      margin-top: 3px;
    }

    .close{
      margin-top: 3px;
    }
}

  /* Next step */
  .nextStep{
    width: 100%;
    z-index: 9;
    background: white;
    margin-bottom: 6px;

    /* Mobile */
    @media screen and (max-width: 812px) {
      margin-bottom: 2px;
    }


    /* If not active */
    &.notActive{
    	display: none;
    }

  }

</style>



// WEBPACK FOOTER //
// NextStep.vue?051c20aa